import React, {Component} from "react";
import './index.less'
import EventBus from '///utils/eventBus'
export default class PortalContentIntroduction extends Component{
    constructor(props) {
        super(props)


        this.state = {
            title:"平台介绍",
            desc1:"广联达睿答平台（IQbots）是集机器人创建、配置、运营于一体的一站式行业智能对话平台，赋能业务产品快速升级智能对话能力。",
            desc2:"没有开发能力者，可以通过睿答平台快速搭建问答型机器人，实现用户与产品的智能对话与互动。可以根据产品形态选择网站、微信公众号、APP、桌面客户端等渠道完成机器人的对接，整个过程无需开发人员参与。",
            desc3:"有开发能力者，可以使用睿答平台开放的API接口，定制个性化的任务及终端UI。",
            // 渠道展示
            introductionChannels:[
                {key:"introductionChannels1",title:"网页端（web/H5）" , icon:'iconwangye-icon',},
                {key:"introductionChannels2",title:"移动端APP" , icon:"iconshouji-icon"},
                {key:"introductionChannels3",title:"桌面客户端" , icon:'iconzhuomiankehuduan'},
                {key:"introductionChannels4",title:"微信公众号" , icon:"iconwechat-icon"},
                {key:"introductionChannels5",title:"API" , icon:"iconapi-2"},
            ],
            introductionTagTechnology:[
                {key:"introductionTagTechnology1",title:"智能问答" , icon:"iconzhinengzhushou"},
                {key:"introductionTagTechnology2",title:"语音识别" , icon:"iconyuyinshibie"},
                {key:"introductionTagTechnology3",title:"语音合成" , icon:"iconyuyinhecheng"},
                {key:"introductionTagTechnology4",title:"知识运营" , icon:"iconzhishiyunying-icon"},
                {key:"introductionTagTechnology5",title:"人机协作" , icon:"iconrenjixiezuo"},
                {key:"introductionTagTechnology6",title:"一键模型训练" , icon:"iconyijianmoxingxunlian"},
                {key:"introductionTagTechnology7",title:"数据分析" , icon:"iconshujufenxi"},
                {key:"introductionTagTechnology8",title:"业务系统对接" , icon:"iconyewuxitongduijie"},
            ],
            introductionMethods:[
                {
                    key:"introductionMethods1",
                    title:"智能客服" ,
                    icon:'iconzhinengkefu-icon',
                    desc:"可解决企业重复繁琐、高人力成本、低用户体验等问题，提供智能问答、人机协作、知识运营等技能，代替人工，智能化解决业务咨询及办理等相关事务。"
                },
                {
                    key:"introductionMethods2",
                    title:"智能助理" ,
                    icon:'iconzhinengzhushou',
                    desc:"深入业务，可以提供解决方案查询、资料索取、业务问答等一系列服务，智能优化工作的全流程。"
                },
                {
                    key:"introductionMethods3",
                    title:"任务服务" ,
                    icon:'iconrenwufuwu',
                    desc:"与业务深度结合，机器人可以根据指令完成一系列指定任务。动态业务问答、BI界面操控、硬件操控等应用场景"
                },
            ],
            introductionService:[
                {
                    key:"introductionService1",
                    title:"规划" ,
                    desc1:"·业务场景评估 <br/> ·业务流程规划",
                    desc2:"·技术方案设计 <br/> ·对接方案设计",
                },
                {
                    key:"introductionService2",
                    title:"交付" ,
                    desc1:"·专属知识库冷启动 <br/> ·专属模型训练",
                    desc2:"·问答效果调优 <br/> ·系统操作答疑",
                },
                {
                    key:"introductionService3",
                    title:"运营" ,
                    desc1:"·知识库运营指导",
                    desc2:"·数据运营",
                },
            ],

            introductionKnowledge:"行业知识层：建筑行业知识库（行业词库、行业知识图谱）",
            introductionTechnology:"通用技术层：NLP、深度学习、知识图谱等",
        }
    }

    bindEvent = () => {
        let _this = this
        EventBus.on('content-tag-fix-flag',(params = {}) => {
            _this.setState({
                contentTagFixFlag:params.contentTagFixFlag
            })
        })
    }

    componentDidMount() {
        this.bindEvent()
    }

    render() {
        let {
            title , desc1, desc2 ,desc3 ,
            introductionChannels, introductionTagTechnology, introductionMethods, introductionService,
            introductionKnowledge,introductionTechnology,
            contentTagFixFlag
        } = this.state
        return (
            <div className={'portal-content-introduction w1200'} id={'portalIntroduction'}>
                {
                    <div style={{height: contentTagFixFlag  ? 48 : 0 }}></div>
                }
                <h2>{title}</h2>
                <div className={'portal-content-introduction-desc'}>
                    <p>
                        <span>{desc1}</span>
                    </p>
                    <p>
                        <span>{desc2}</span>
                    </p>
                    <p>
                        <span>{desc3}</span>
                    </p>
                </div>
                <div style={{display:"none"}} className={'portal-content-introduction-channel'}>
                    <h3>对接渠道多样化，零/低代码分钟级接入</h3>
                    <ul>
                        {introductionChannels.map(ele => <li key={ele.key}><span className={`icon iconfont ${ele.icon}`}></span><p>{ele.title}</p></li>)}
                    </ul>
                </div>
                <div style={{display:"none"}} className={'portal-content-introduction-tags'}>
                    <ul>
                        <li>
                            <h2>技能</h2>
                            <ul className={"portal-content-introduction-tag-technology"}>
                                {introductionTagTechnology.map(ele => <li key={ele.key}><span className={`icon iconfont ${ele.icon}`}></span><p>{ele.title}</p></li>)}
                            </ul>
                        </li>
                        <li>
                            <h2>解决方案</h2>
                            <ul className={"portal-content-introduction-methods-technology"}>
                                {introductionMethods.map(ele => {
                                    return (
                                        <li key={ele.key}>
                                            <span className={`icon iconfont ${ele.icon}`}></span>
                                            <h5>{ele.title}</h5>
                                            <p>{ele.desc}</p>
                                        </li>

                                    )
                                })}
                            </ul>
                        </li>
                        <li>
                            <h2>服务与支持</h2>
                            <ul className={"portal-content-introduction-service-technology"}>
                                {introductionService.map(ele => {
                                    return (
                                        <li key={ele.key}>
                                            <h5>{ele.title}</h5>
                                            <div style={{overflow:'hidden',display:'flex', justifyContent: 'space-around'}}>
                                                <p style={{textAlign:'left',minWidth:115}} dangerouslySetInnerHTML={{__html:ele.desc1}}></p>
                                                <p style={{textAlign:'left',minWidth:115}} dangerouslySetInnerHTML={{__html:ele.desc2}}></p>
                                            </div>
                                        </li>
                                    )
                                })}
                            </ul>
                        </li>
                    </ul>
                </div>
                <div style={{display:"none"}} className={'portal-content-introduction-knowledge'}><h3>{introductionKnowledge}</h3></div>
                <div style={{display:"none"}} className={'portal-content-introduction-technology'}><h3>{introductionTechnology}</h3></div>

            </div>
        )
    }
}